import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainPage from "./components/MainPage/MainPage";
import Reservas from "./components/Reservas/Reservas";
import CancelarReserva from "./components/CancelarReserva/CancelarReserva";
import Servicios from "./components/Servicios/Servicios";
import ServiciosVip from "./components/ServiciosVip/ServiciosVip";
import CitasEspeciales from "./components/CitasEspeciales/CitasEspeciales";
import Trabajos from "./components/Trabajos/Trabajos";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<MainPage />} />
                <Route path="/reservas" element={<Reservas />} />
                <Route path="/booking/:id" element={<CancelarReserva />} />
                <Route path="/servicios" element={<Servicios />} />
                <Route path="/vip" element={<ServiciosVip />} />
                <Route path="/citas-especiales" element={<CitasEspeciales />} />
                <Route path="/trabajos" element={<Trabajos />} />
            </Routes>
        </Router>
    );
}

export default App;
